module.exports = __webpack_public_path__ + "static/media/checkin_icon.469268a5.svg";